import { useState, useEffect, useRef, ReactElement } from "react";
import * as React from "react";
import { Button, IButtonProps } from "@telusinternationalai/seibun-ui";
import classNames from "classnames";
import styled from "styled-components";

import { reportError } from "../../services/common";

const StyledButton = styled(Button)`
  * {
    pointer-events: none;
  }
`;

const SeibunButton = ({
  disabled,
  children,
  onClick: onClickProps,
  isLoading = false,
  className,
  hidden,
  ...props
}: IButtonProps): ReactElement => {
  const isMounted = useRef(true);
  useEffect(
    () => (): void => {
      isMounted.current = false;
    },
    []
  );

  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const onClick = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): Promise<void> => {
    if (!onClickProps) {
      return;
    }

    setIsButtonLoading(true);
    try {
      await onClickProps(event);
    } catch (err) {
      reportError(err);
    } finally {
      if (isMounted.current) {
        setIsButtonLoading(false);
      }
    }
  };

  const showSpinner = isButtonLoading || isLoading;
  return (
    <StyledButton
      className={classNames(className, hidden ? undefined : "d-inline-flex")}
      onClick={onClick}
      disabled={showSpinner || disabled}
      isLoading={showSpinner}
      hidden={hidden}
      title={showSpinner ? "Loading" : undefined}
      type="button"
      {...props}
    >
      {children}
    </StyledButton>
  );
};

export default SeibunButton;
